// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3XUPv","colBig":"styles_colBig__3TiV3","colSmall":"styles_colSmall__xpB1c"};